<script lang="ts">
    import {getLocalization} from 'core/svelte-context/context';
    import KpGenericPanel from 'shared/ui-widgets/panel/KpGenericPanel.svelte';

    const localize = getLocalization();
</script>

<KpGenericPanel>
    <svelte:fragment slot="heading">
        {localize(/* @kp-localization hledani.vyhledavaniAutort */ 'hledani.vyhledavaniAutort')}
    </svelte:fragment>

    <form action="/search">
        <input type="hidden" name="kind" value="record"/>
        <input type="hidden" name="subkind" value="authority"/>
        <div class="input-group">
            <input type="text" class="form-control" name="q" value=""/>
            <span class="input-group-btn">
                <button type="submit" class="btn btn-primary">
                    {localize(/* @kp-localization commons.hledat */ 'commons.hledat')}
                </button>
            </span>
        </div>
    </form>
</KpGenericPanel>


